import { FC, MouseEventHandler } from "react";
import { Button } from "@mui/material";
import { LoadingContainer } from "./style";
import { Spin } from "antd";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LogoutIcon from "@mui/icons-material/Logout";
import DashboardButton from "../DashboardButton/DashboardButton";

export interface LoginButtonProps {
  onLogin: MouseEventHandler<HTMLButtonElement>;
  onLogout: MouseEventHandler<HTMLElement>;
  onAccountManagementRequest: MouseEventHandler<HTMLElement>;
  profile?: Record<string, unknown>;
  loading: boolean;
  widthFull?: boolean;
  stateDrawer?: boolean;
}

export const LoginButton: FC<LoginButtonProps> = ({
  onLogin,
  onLogout,
  onAccountManagementRequest,
  profile,
  loading,
  widthFull,
  stateDrawer,
}) => {
  const content = (
    <div className="xvia-header-list-buttons">
      {loading ? (
        <LoadingContainer>
          <Spin />
        </LoadingContainer>
      ) : (
        <>
          {!profile ? (
            <Button
              onClick={onLogin}
              startIcon={<PersonOutlineIcon />}
              variant="contained"
              className="buttonTop buttonTop-profile-anonymous"
              sx={{
                backgroundColor: "#FFFFFF",
                color: "#004660",
                borderRadius: "999px",
                textTransform: "none",
                fontWeight: "500",
                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
              }}
            >
              Entrar
            </Button>
          ) : (
            <>
              <DashboardButton />
              <Button
                key="logout"
                sx={{
                  color: "#FFFFFF",
                  fontSize: "16px",
                  fontWeight: "800",
                  fontFamily: "Montserrat",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
                onClick={(e) => onLogout(e)}
                endIcon={<LogoutIcon />}
              >
                Sair
              </Button>
            </>
          )}
        </>
      )}
    </div>
  );

  return content;
};
